/**
 * Admin user-context types. Mirrors the backend's
 * `AdminApplication.Features.Admin.AdminUsers.GetCurrentContext.ResultModel`.
 */

export interface AdminUserContext {
	// Identity
	adminUserId: string;
	email: string;
	displayName?: string | null;
	firstName?: string | null;
	lastName?: string | null;
	jobTitle?: string | null;
	department?: string | null;

	// Authorization
	isSystemAdmin: boolean;
	roles: string[];
	permissions: string[];

	// Impersonation context
	bypassTenantFilter: boolean;
	impersonatedClientId?: string | null;
}

export const emptyAdminUserContext: AdminUserContext = {
	adminUserId: "",
	email: "",
	displayName: null,
	firstName: null,
	lastName: null,
	jobTitle: null,
	department: null,
	isSystemAdmin: false,
	roles: [],
	permissions: [],
	bypassTenantFilter: false,
	impersonatedClientId: null,
};

/** API envelope shape (matches the backend's ResultWrapper<T> serialization). */
export interface ApiResponse<T> {
	result: T;
	status: number;
	messages: string[];
}
